import moment from 'moment';

const getTimezone = () => {
  return moment.tz.guess();
};

export default getTimezone;